import { render, staticRenderFns } from "./ChannelBackendEntityAssociationCmp.vue?vue&type=template&id=25d6e912&scoped=true&"
import script from "./ChannelBackendEntityAssociationCmp.vue?vue&type=script&lang=js&"
export * from "./ChannelBackendEntityAssociationCmp.vue?vue&type=script&lang=js&"
import style0 from "./ChannelBackendEntityAssociationCmp.vue?vue&type=style&index=0&id=25d6e912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6e912",
  null
  
)

export default component.exports